module.exports = __webpack_public_path__ + "img/ok51929.76527f71.png";